module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "reviewPage",
    attrs: {
      "id": "pra01"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagei"
    }
  }, [_c('h2', {
    staticClass: "reviewPageHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PRAISE FOR MIKE DOOLEY’S NOTES FROM THE UNIVERSE")])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“Thank you for all the joy and tears that you have given me. I don’t think people always get the full recognition that they deserve. I just wanted to take the time to let you know that you’ve affected one person’s life…forever.”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“I cannot thank you enough for the inspiration, love, and feeling of belonging to something so huge and powerful. It lifts me straight up each day. Thank you, thank you, thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“I want to thank Mike for the daily notes; they are such an inspiration. It is so amazingly wonderful to find someone who has put into words what I have thought for years. Thank you from the bottom of my heart.”")])]), _c('a', {
    attrs: {
      "id": "pageii"
    }
  }, [_c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“Mike, you missed your calling, you are most definitely a comedian. Thank you for sharing in this life journey daily and keeping the veil lifted. You are awesome. I love you.”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“I’ve subscribed to lots of these things and they lose their charge, start to get repetitive, etc. But I have to hand it to you, Mike—you keep me hoppin’ and I just LOVE IT! WHAT A BLAST this is—definitely sounds like you’re talkin’ just to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“I receive messages from other best-selling spiritual gurus on the internet, but your messages are the most profound, heartwarming, everyday-commonsense, take-it-with-you, mind-uplifting, and unselfish messages received. THANK YOU, Mike! Blessings to you and your good work.”")])]), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('a', {
    attrs: {
      "id": "pageii"
    }
  }, [_vm._v("“I used to REALLY, REALLY look forward to weekends. But since I started receiving the daily Notes from the Universe on Monday through Friday, weekends are not such a big deal now. I even look forward to coming back to work on Monday, since I know that I will feel loved and valued because of the Universe. Kind of makes me realize what’s ")]), _c('a', {
    attrs: {
      "id": "pageiii"
    }
  }, [_vm._v("really important in life…at least in my life. Thanks for all of the encouragement. I couldn’t make it without you.”")])]), _c('a', {
    attrs: {
      "id": "pageiii"
    }
  }, [_c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“You may not have my faith in Jesus or in the Holy Spirit or in God as my Heavenly Loving Father, but, nevertheless, your Notes from the Universe are helping me live the Covenant Spiritual Life I have been wanting to live for a very long time. I just thought you would like to know this, and I wanted to say THANK YOU for helping me to bring Glory to my Lord.”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“I don’t know if you know it or not, but to some of us out here your messages are vitally important, that consistent light that helps guide and strengthen faith to keep us going and give us courage to reach further and to strive toward spiritual growth and happiness—toward a more meaningful and fulfilling life. You are doing such a wonderful and thoughtful thing for so many of us, I just wanted to say thank you!! Eternally grateful.”")])]), _c('p', {
    staticClass: "reviewPageText"
  }, [_c('a', {
    attrs: {
      "id": "pageiii"
    }
  }, [_vm._v("“Thank you, Mike. You may never know how much this note means to me today, but I do hope that my ")]), _c('a', {
    attrs: {
      "id": "pageiv"
    }
  }, [_vm._v("gratitude will in some way reach you and bless your life in ways that make even a bright light like you stop and go WOW!”")])]), _c('a', {
    attrs: {
      "id": "pageiv"
    }
  }, [_c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“For several years I’ve enjoyed your messages and they never fail to touch my heart. Thanks so much, Mike, for all you do for everyone and, yes, especially for me. I feel like your messages come to me with heartfelt sincerity…and I won’t even ask you, ‘How DO you do it?’ You are obviously well connected. Thanks again.”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“I appreciate your messages. They are like golden nuggets that bless and inspire me. ‘Thank you’ is an understatement, but I must say it anyway: Thank you.”")])])]), _c('a', {
    attrs: {
      "id": "pageiv"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-531f6850","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781416594161_pra01.vue
// module id = 63
// module chunks = 0